goog.provide("shadow.js.shim.module$src$svg$location$map_marker_svg");
goog.provide("module$shadow_js_shim_module$src$svg$location$map_marker_svg");
shadow.js.shim.module$src$svg$location$map_marker_svg = shadow.js.nativeProvides["src/svg/location/map-marker.svg"] = shadow$bridge("src/svg/location/map-marker.svg");
module$shadow_js_shim_module$src$svg$location$map_marker_svg.default = shadow.js.shim.module$src$svg$location$map_marker_svg;
